module.exports = __webpack_public_path__ + "img/overlay-loader.81ab1efb.gif";